import React from 'react';
import "../template-file-css/document-file-template.css";


export const RFS_CrisisPlanSafetyPlan = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='RFS_CrisisPlanSafetyPlan' className='file-pdf-document'>
            <div className='file-template'>
            <p className='w-750'><center><h4>Crisis Safety Plan</h4></center>
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtName' name='txtName' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='date' id='txtDate' name='txtDate' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Step 1: What are the warning signs (thoughts, images, mood, situation, behavior) that a crisis may
                    be developing:</span>
                    1.<input type='text' id='txtWhatAreTheWarningSigns_1' name='txtWhatAreTheWarningSigns_1' className='add-only w-730 custom-add-only' /><br />
                    2.<input type='text' id='txtWhatAreTheWarningSigns_2' name='txtWhatAreTheWarningSigns_2' className='add-only w-730 custom-add-only' /><br />
                    3.<input type='text' id='txtWhatAreTheWarningSigns_3' name='txtWhatAreTheWarningSigns_3' className='add-only w-730 custom-add-only' /><br />
                </p>

                <p className='w-750'><span className='eleHeader'>Step 2: What internal coping strategies do you have- Things you can do to take your mind off of
                    your problems without contacting another person (relaxation technique, physical activity).</span>
                    1.<input type='text' id='txtWhatInternalCopingStrategiesDoYouThings_1' name='txtWhatInternalCopingStrategiesDoYouThings_1' className='add-only w-730 custom-add-only' /><br />
                    2.<input type='text' id='txtWhatInternalCopingStrategiesDoYouThings_2' name='txtWhatInternalCopingStrategiesDoYouThings_2' className='add-only w-730 custom-add-only' /><br />
                    3.<input type='text' id='txtWhatInternalCopingStrategiesDoYouThings_3' name='txtWhatInternalCopingStrategiesDoYouThings_3' className='add-only w-730 custom-add-only' /><br />
                </p>

                <p className='w-750'><span className='eleHeader'>Step 3: People and social settings that provide distractions </span>
                    1.<input type='text' id='txtPeopleAndSocialSettingsThatProvide_1' name='txtPeopleAndSocialSettingsThatProvide_1' className='add-only w-730 custom-add-only' /><br />
                    2.<input type='text' id='txtPeopleAndSocialSettingsThatProvide_2' name='txtPeopleAndSocialSettingsThatProvide_2' className='add-only w-730 custom-add-only' /><br />
                    3.<input type='text' id='txtPeopleAndSocialSettingsThatProvide_3' name='txtPeopleAndSocialSettingsThatProvide_3' className='add-only w-730 custom-add-only' /><br />
                </p>

                <p className='w-750'><span className='eleHeader'>Step 4: People whom you can ask for help </span>
                    1.<input type='text' id='txtPeopleWhomYouCanAskForHelp_1' name='txtPeopleWhomYouCanAskForHelp_1' className='add-only w-730 custom-add-only' /><br />
                    2.<input type='text' id='txtPeopleWhomYouCanAskForHelp_2' name='txtPeopleWhomYouCanAskForHelp_2' className='add-only w-730 custom-add-only' /><br />
                    3.<input type='text' id='txtPeopleWhomYouCanAskForHelp_3' name='txtPeopleWhomYouCanAskForHelp_3' className='add-only w-730 custom-add-only' /><br />
                </p>

                <p className='w-750'><h4>Step 5: Professionals or agencies you can contact during a crisis </h4></p>

                <table>
                    <tr>
                        <td className='w-30'>&nbsp;</td>
                        <td className='w-240'>
                            <span className='eleHeader'>Clinician Name</span></td>
                        <td className='w-240'>
                            <span className='eleHeader'>Phone:</span></td>
                        <td className='w-240'>
                            <span className='eleHeader'>Clinician Emergency Contact</span></td>
                    </tr>
                    <tr>
                        <td className='w-30'>1.</td>
                        <td className='w-240'>
                            <input type='text' id='txtClinicianName_1' name='txtClinicianName_1' className='add-only' /></td>
                        <td className='w-240'>
                            <input type='text' id='txtPhone_1' name='txtPhone_1' className='add-only' /></td>
                        <td className='w-240'>
                            <input type='text' id='txtClinicianEmergency_1' name='txtClinicianEmergency_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-30'>2.</td>
                        <td className='w-240'>
                            <input type='text' id='txtClinicianName_2' name='txtClinicianName_2' className='add-only' /></td>
                        <td className='w-240'>
                            <input type='text' id='txtPhone_2' name='txtPhone_2' className='add-only' /></td>
                        <td className='w-240'>
                            <input type='text' id='txtClinicianEmergency_2' name='txtClinicianEmergency_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-30'>3.</td>
                        <td className='w-720'>
                            <span className='eleHeader'>Local Urgent Care Services</span></td>
                    </tr>
                    <tr>
                        <td className='w-30'>&nbsp;</td>
                        <td className='w-720'>
                            <input type='text' id='txtLocalUrgentCareServices' name='txtLocalUrgentCareServices' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-30'>&nbsp;</td>
                        <td className='w-720'>
                            <span className='eleHeader'>Urgent Care Services Address</span></td>
                    </tr>
                    <tr>
                        <td className='w-30'>&nbsp;</td>
                        <td className='w-720'>
                            <input type='text' id='txtUrgentCareServicesAddress' name='txtUrgentCareServicesAddress' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-30'>&nbsp;</td>
                        <td className='w-720'>
                            <span className='eleHeader'>Urgent Care Services Phone</span></td>
                    </tr>
                    <tr>
                        <td className='w-30'>&nbsp;</td>
                        <td className='w-720'>
                            <input type='text' id='txtUrgentCareServicesPhone' name='txtUrgentCareServicesPhone' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-30'>4.</td>
                        <td className='w-720'>
                            <span className='eleHeader'>Suicide Prevention Lifeline Phone:</span></td>
                    </tr>
                    <tr>
                        <td className='w-30'>&nbsp;</td>
                        <td className='w-720'>
                            <input type='text' id='txtSuicidePreventionPhone' name='txtSuicidePreventionLifeLinePHone'  className='add-only' defaultValue={'1-800-273-TALK (8255)'} /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Step 6: Making the environment safe: </span>
                    1.<input type='text' id='txtMakingTheEnvironmentSafe_1' name='txtMakingTheEnvironmentSafe_1' className='add-only w-730 custom-add-only' /><br />
                    2.<input type='text' id='txtMakingTheEnvironmentSafe_2' name='txtMakingTheEnvironmentSafe_2' className='add-only w-730 custom-add-only' /><br />

                </p>

                <p className='w-750'><center><h3><b>RISE Family Services</b></h3></center>
                    <center><h4>Crisis Support Plan</h4></center></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtName_1' name='txtName_1' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='date' id='txtDate_1' name='txtDate_1' className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>I understand that suicidal risk is to be taken very seriously. I want to help &nbsp;
                    <input type='text' id='txtUnderstandThatSuicidal' name='txtUnderstandThatSuicidal' className='add-only w-200 custom-add-only' /> &nbsp;
                    find new ways of managing stress in times of crisis. I realize there are no guarantees about how
                    crises resolve, and that we are making reasonable efforts to maintain safety for everyone. In some
                    cases inpatient hospitalization may be necessary. </p>

                <p className='w-750'><span className='eleHeader'>Things I can do:</span>
                    <input type='text' id='txtThingsCanDo' name='txtThingsCanDo' className='add-only' /></p>

                <p className='w-750'><span className='eleHeader'>Provide encouragement and support</span>
                    1.<input type='text' id='txtProvideEncouragementAndSupport_1' name='txtProvideEncouragementAndSupport_1' className='add-only w-700 custom-add-only' /><br />
                    2.<input type='text' id='txtProvideEncouragementAndSupport_2' name='txtProvideEncouragementAndSupport_2' className='add-only w-700 custom-add-only' /><br />
                </p>

                <p className='w-750'>Help &nbsp;<input type='text' id='txtHelp' name='txtHelp' className='add-only w-200 custom-add-only' /> &nbsp;follow his/her Safety Plan
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Ensure a safe environment:</span></p>
                <ol>
                    <li>Remove all fire arms and ammunition </li>
                    <li>Remove or lock up
                        Knives, razors and other sharp objects
                        Prescriptions and over the counter drugs (including vitamins and aspirins)
                        Alcohol, illegal drugs and related paraphernalia </li>
                    <li>Make sure someone is available to provide personal support and monitor him/her at all
                        times during crisis and afterwards as needed </li>
                    <li>Pay attention to his/her stated method of suicide/self injury and restrict access to vehicle,
                        ropes, flammable and etc as appropriate</li>
                    <li>Limit or restrict access to vehicle/car keys as appropriate </li>
                    <li>Identify people who might escalate risk for the client and minimized their contact with the
                        client</li>
                    <li>Provide access to things client identifies as helpful and encourage healthful behaviors such
                        as good nutrition and adequate rest</li>
                </ol>

                <p className='w-750'>Other:&nbsp;<input type='text' id='txtOther' name='txtOther' className='add-only w-700 custom-add-only' />
                    <br />
                    If I am unable to continue to provide these supports, or if I believe that the Crisis Safety Plan is
                    not helpful of sufficient, I will contact the direct service worker, rehabilitation specialist and
                    therapist immediately and express my concerns.
                    <br />
                    If I believe <input type='text' id='txtIfBelieve' name='txtIfBelieve' className='add-only w-200 custom-add-only' />is a danger to self or others, I agree to:
                    Call direct service worker, rehabilitation specialist and therapist. <br />
                    Or call 911 <br />
                    Or help <input type='text' id='txtOrHelp' name='txtOrHelp' className='add-only w-200 custom-add-only' />get to a hospital
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>I agree to follow by this plan until</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtAgreeToFollowByPlanUntil' name='txtAgreeToFollowByPlanUntil' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Support signature:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Client Signature:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtSupportSignature' name='txtSupportSignature' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtClientSignature' name='txtClientSignature' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Direct Service Worker:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Rehabilitation Specialist:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtDirectServiceWorker' name='txtDirectServiceWorker' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtRehabilitationSpecialist' name='txtRehabilitationSpecialist' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Therapist:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtTherapist' name='txtTherapist' className='add-only' /></td>
                    </tr>
                </table>





                
            </div>
        </form>
    )
}